/* Esselle Home – homepage components · v13. Vanilla JS, no dependencies, ~5KB gzipped. */
(function () {
  'use strict';
  if (window.__ehHome) return;
  window.__ehHome = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Measurement (Microsoft Clarity + Shopify customer events) ----------
     Every EH section reports when it is first seen and when something in it is clicked,
     so Clarity can filter recordings and heatmaps by section. Event names:
       eh_seen_<section>, eh_click_<section>, eh_sample_add, eh_cart_add, eh_search
     Sessions are tagged eh_home = v13, so you can compare before and after. */
  var VERSION = 'v13';
  function track(name, data) {
    if (designMode) return;
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, data || {});
    } catch (e) {}
  }
  var NAMES = { cats: 'categories', shopby: 'shop_by', cols: 'collections', dd: 'design', split: 'made_to_measure', partners: 'stockists', look: 'shop_the_look' };
  function sectionKey(el) {
    var sec = el && el.closest ? el.closest('.eh') : null;
    if (!sec) return '';
    for (var i = 0; i < sec.classList.length; i++) {
      var c = sec.classList[i];
      if (c.indexOf('eh-') === 0 && c.indexOf('--') === -1) { c = c.slice(3); return NAMES[c] || c.replace(/-/g, '_'); }
    }
    return 'section';
  }
  try { if (!designMode && typeof window.clarity === 'function') window.clarity('set', 'eh_home', VERSION); } catch (e) {}

  var seenIo = ('IntersectionObserver' in window && !designMode)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          seenIo.unobserve(e.target);
          track('eh_seen_' + sectionKey(e.target), { version: VERSION });
        });
      }, { threshold: 0.2 })
    : null;
  function watchSections(scope) {
    if (!seenIo) return;
    (scope || document).querySelectorAll('.eh:not([data-eh-seen])').forEach(function (sec) {
      if (!sec.offsetParent && sec.getClientRects().length === 0) return;   // hidden / invisible sections
      sec.setAttribute('data-eh-seen', '');
      seenIo.observe(sec);
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('.eh a[href], .eh button');
    if (!el || el.hasAttribute('data-eh-add') || el.hasAttribute('data-eh-prev') || el.hasAttribute('data-eh-next')) return;
    var key = sectionKey(el);
    if (key) track('eh_click_' + key, { label: (el.textContent || el.getAttribute('aria-label') || '').trim().slice(0, 60), url: el.getAttribute('href') || '' });
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.classList && f.classList.contains('eh-search')) {
      var q = f.querySelector('input[name="q"]');
      track('eh_search', { query: q ? q.value.trim().slice(0, 80) : '' });
    }
  }, true);

  /* ---------- Reveal on scroll ---------- */
  // Clipped ("unroll") elements have no visible area, so we observe an unclipped
  // proxy (their parent) and reveal the element when the proxy enters the viewport.
  var targets = new WeakMap();
  var io = ('IntersectionObserver' in window && !designMode)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          (targets.get(e.target) || []).forEach(function (el) { el.classList.add('is-in'); });
          targets.delete(e.target);
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  function observe(scope) {
    (scope || document).querySelectorAll('[data-eh-reveal]:not(.is-in), .eh-fan:not(.is-in)').forEach(function (el) {
      if (!io || reduceMotion.matches) { el.classList.add('is-in'); return; }
      var proxy = el.getAttribute('data-eh-reveal') === 'unroll' ? (el.parentElement || el) : el;
      while (proxy !== el && proxy.parentElement && getComputedStyle(proxy).display === 'contents') proxy = proxy.parentElement;
      var list = targets.get(proxy);
      if (list) { list.push(el); return; }
      targets.set(proxy, [el]);
      io.observe(proxy);
    });
  }

  /* ---------- Deferred hero images (later slides) ---------- */
  function undefer(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-eh-srcset], [data-eh-src]').forEach(function (el) {
      if (el.dataset.ehSrcset) { el.setAttribute('srcset', el.dataset.ehSrcset); el.removeAttribute('data-eh-srcset'); }
      if (el.dataset.ehSrc) { el.setAttribute('src', el.dataset.ehSrc); el.removeAttribute('data-eh-src'); }
    });
  }
  function afterLoad(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn, { once: true });
  }
  afterLoad(function () {
    var go = function () { document.querySelectorAll('eh-hero').forEach(undefer); };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 800);
  });

  /* ---------- Hero slider ---------- */
  class EhHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.eh-hero__slide'));
      if (this.slides.length < 2) return;
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.eh-hero__dot'));
      this.counter = this.querySelector('[data-eh-count]');
      this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
      this.delay = (parseFloat(this.dataset.autoplay) || 0) * 1000;
      this.style.setProperty('--eh-dur', this.delay + 'ms');

      var self = this;
      var prev = this.querySelector('[data-eh-prev]');
      var next = this.querySelector('[data-eh-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });

      var x0 = null, y0 = null;
      this.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; }, { passive: true });
      this.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) self.go(self.index + (dx < 0 ? 1 : -1));
      });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') self.go(self.index - 1);
        if (e.key === 'ArrowRight') self.go(self.index + 1);
      });
      ['mouseenter', 'focusin'].forEach(function (ev) { self.addEventListener(ev, function () { self.pause(); }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { self.addEventListener(ev, function () { if (!self.editing) self.play(); }); });
      this._vis = function () { document.hidden ? self.pause() : self.play(); };
      document.addEventListener('visibilitychange', this._vis);

      // Only autoplay once the hero is on screen
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (en) { en[0].isIntersecting ? self.play() : self.pause(); }, { threshold: .3 });
        this._io.observe(this);
      } else { this.play(); }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this._io) this._io.disconnect();
      document.removeEventListener('visibilitychange', this._vis);
    }
    go(i) {
      var n = this.slides.length;
      i = ((i % n) + n) % n;
      var self = this;
      this.slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.classList.remove('is-first');
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
        if (on) {
          // Lazy slides: promote their image so it's ready
          undefer(s);
          s.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        }
      });
      // preload the next slide's image quietly
      var nxt = this.slides[(i + 1) % n];
      if (nxt) { undefer(nxt); nxt.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; }); }
      this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (this.counter) this.counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
      this.index = i;
      if (this.classList.contains('is-playing')) {
        this.classList.remove('is-playing'); void this.offsetWidth; this.play();
      }
    }
    play() {
      clearTimeout(this.timer);
      if (!this.delay || reduceMotion.matches || designMode || this.slides.length < 2) return;
      var self = this;
      this._want = true;
      // Autoplay starts once the page has fully loaded, so slide 1 stays the page's main image while it loads
      if (document.readyState !== 'complete') {
        if (!this._waiting) {
          this._waiting = true;
          afterLoad(function () { self._waiting = false; if (self._want) self.play(); });
        }
        return;
      }
      this.classList.add('is-playing');
      this.timer = setTimeout(function () { self.go(self.index + 1); }, this.delay);
    }
    pause() { this._want = false; clearTimeout(this.timer); this.classList.remove('is-playing'); }
  }

  /* ---------- Rail (scroll-snap list with arrows, progress bar and mouse drag) ---------- */
  class EhRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.eh-rail__track');
      if (!this.track || this._ready) return;
      this._ready = true;
      this.prev = this.querySelector('[data-eh-prev]');
      this.next = this.querySelector('[data-eh-next]');
      var self = this, t = this.track, raf = null;

      // Progress bar – shows there is more to see, and where you are
      this.progress = this.querySelector('.eh-rail__progress');
      if (!this.progress) {
        this.progress = document.createElement('div');
        this.progress.className = 'eh-rail__progress';
        this.progress.setAttribute('aria-hidden', 'true');
        this.progress.appendChild(document.createElement('span'));
        t.insertAdjacentElement('afterend', this.progress);
      }
      this.thumb = this.progress.firstElementChild;

      var step = function (dir) {
        var item = t.children[0];
        var w = item ? item.getBoundingClientRect().width : t.clientWidth * .8;
        var per = Math.max(1, Math.floor((t.clientWidth + 1) / w));
        t.scrollBy({ left: dir * w * per, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };
      if (this.prev) this.prev.addEventListener('click', function () { step(-1); });
      if (this.next) this.next.addEventListener('click', function () { step(1); });

      this.update = function () {
        raf = null;
        var max = t.scrollWidth - t.clientWidth;
        var scrollable = max > 4;
        self.classList.toggle('is-scrollable', scrollable);
        if (self.prev) self.prev.disabled = t.scrollLeft <= 2;
        if (self.next) self.next.disabled = t.scrollLeft >= max - 2;
        if (scrollable && self.thumb) {
          var size = Math.max(12, (t.clientWidth / t.scrollWidth) * 100);
          self.thumb.style.width = size + '%';
          self.thumb.style.left = ((t.scrollLeft / max) * (100 - size)) + '%';
        }
      };
      t.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(self.update); }, { passive: true });
      if ('ResizeObserver' in window) { this._ro = new ResizeObserver(this.update); this._ro.observe(t); }

      // Mouse drag (desktop). Touch already swipes natively.
      var drag = null, suppressClick = false;
      var onMove = function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) > 6) { drag.moved = true; t.classList.add('is-dragging'); }
        if (drag.moved) t.scrollLeft = drag.left - dx;
      };
      var onUp = function () {
        if (!drag) return;
        suppressClick = drag.moved;
        drag = null;
        t.classList.remove('is-dragging');
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        if (suppressClick) setTimeout(function () { suppressClick = false; }, 0);
      };
      t.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || !self.classList.contains('is-scrollable')) return;
        if (e.target.closest('button, input, select, textarea')) return;
        drag = { x: e.clientX, left: t.scrollLeft, moved: false };
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
      });
      t.addEventListener('click', function (e) { if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; } }, true);
      t.addEventListener('dragstart', function (e) { if (drag) e.preventDefault(); });

      this.update();
    }
    disconnectedCallback() { if (this._ro) this._ro.disconnect(); this._ready = false; }
  }

  /* ---------- Tabs ---------- */
  class EhTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));
      this.viewAll = this.querySelector('[data-eh-viewall]');
      var self = this;
      this.tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { self.select(i, false); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = self.tabs.length, j = null;
          if (k === 'ArrowRight') j = (i + 1) % n;
          if (k === 'ArrowLeft') j = (i - 1 + n) % n;
          if (k === 'Home') j = 0;
          if (k === 'End') j = n - 1;
          if (j !== null) { e.preventDefault(); self.select(j, true); }
        });
      });
    }
    select(i, focus) {
      var self = this;
      this.tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
        if (on && self.viewAll && t.dataset.url) {
          self.viewAll.href = t.dataset.url;
          if (t.dataset.label) self.viewAll.querySelector('span').textContent = t.dataset.label;
        }
      });
      this.panels.forEach(function (p, k) {
        var on = k === i;
        if (on && p.hidden) {
          p.hidden = false;
          p.classList.remove('is-entering'); void p.offsetWidth; p.classList.add('is-entering');
          p.querySelectorAll('eh-rail').forEach(function (r) { r.update && r.update(); });
        } else if (!on) { p.hidden = true; }
      });
    }
  }

  /* ---------- Hotspots ---------- */
  class EhHotspots extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.btns = Array.prototype.slice.call(this.querySelectorAll('.eh-hotspot__btn'));
      this.btns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = b.getAttribute('aria-expanded') === 'true';
          self.closeAll();
          if (!open) b.setAttribute('aria-expanded', 'true');
        });
      });
      this._doc = function (e) { if (!self.contains(e.target)) self.closeAll(); };
      this._key = function (e) { if (e.key === 'Escape') self.closeAll(); };
      document.addEventListener('click', this._doc);
      document.addEventListener('keydown', this._key);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._doc);
      document.removeEventListener('keydown', this._key);
    }
    closeAll() { this.btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  }

  if (!customElements.get('eh-hero')) customElements.define('eh-hero', EhHero);
  if (!customElements.get('eh-rail')) customElements.define('eh-rail', EhRail);
  if (!customElements.get('eh-tabs')) customElements.define('eh-tabs', EhTabs);
  if (!customElements.get('eh-hotspots')) customElements.define('eh-hotspots', EhHotspots);

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg, ok, viewLabel) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'eh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('eh-toast--error', !ok);
    toastEl.innerHTML = '';
    var span = document.createElement('span'); span.textContent = msg; toastEl.appendChild(span);
    if (ok) {
      var a = document.createElement('a'); a.href = root + 'cart'; a.textContent = viewLabel || 'View cart'; toastEl.appendChild(a);
    }
    requestAnimationFrame(function () { toastEl.classList.add('is-open'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 4200);
  }

  /* ---------- Quick add / sample add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-eh-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.querySelector('span');
    var original = label ? label.textContent : '';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.ehAdd), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'This item could not be added.'); return d; }); })
      .then(function (added) {
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var html = document.documentElement;
            var items = added.items || [added];
            // Prestige 7+ / Maestrooo stack
            html.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } }));
            html.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            // Prestige 5/6
            html.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
            document.querySelectorAll('[data-cart-count], .header__cart-count, cart-count').forEach(function (el) {
              if (el.children.length === 0) el.textContent = cart.item_count;
            });
            btn.classList.add('is-added');
            if (label) label.textContent = btn.dataset.ehAdded || 'Added';
            setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; }, 2400);
            toast(btn.dataset.ehToast || 'Added to your cart', true, btn.dataset.ehView);
            var isSample = btn.dataset.ehKind === 'sample';
            track(isSample ? 'eh_sample_add' : 'eh_cart_add', { variant: Number(btn.dataset.ehAdd), section: sectionKey(btn) });
            try { if (typeof window.clarity === 'function') window.clarity('upgrade', isSample ? 'eh_sample_add' : 'eh_cart_add'); } catch (e) {}
          });
      })
      .catch(function (err) { toast(err.message || 'Something went wrong. Please try again.', false); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('eh-hero');
    if (hero && hero.slides) { hero.editing = true; hero.pause(); hero.go(hero.slides.indexOf(e.target)); }
    var panel = e.target.closest && e.target.closest('[role="tabpanel"]');
    var tabs = panel && panel.closest('eh-tabs');
    if (tabs && tabs.panels) tabs.select(tabs.panels.indexOf(panel), false);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hero = e.target.closest && e.target.closest('eh-hero');
    if (hero) { hero.editing = false; hero.play(); }
  });

  function init() { observe(); watchSections(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();